module.exports = __webpack_public_path__ + "static/media/wbtc.bfefd418.png";